var swiper = new Swiper(".js-thumbs-slider", {
    
    slidesPerView: "auto",
    spaceBetween: 8,
      navigation: {
        prevEl: ".product-button--next",
        nextEl: ".product-button--prev",
      },breakpoints: { 
        749: {
            direction: "vertical",
            spaceBetween: 16,
            slidesPerView: 4,
        },
          
    },
  });